export default class Exception {

    constructor () {
       
        this.language = {
            choosen: 'ptBR',
            ptBR: {
                exceptions: {
                    except_checkout_contact_issuer: 'Ocorreu um erro na validação dos dados do cartão. Por favor, entre em contato com o emissor do seu cartão de crédito.',
                    except_checkout_contact_support: 'Ocorreu um erro na validação dos dados do cartão. Por favor, entre em contato com o nosso suporte.',
                    except_user_already_exists: 'O e-mail de usuário informado já existe. Favor escolher um novo usuário.',
                    except_not_threated: 'Ocorreu um erro. A equipe da <b>TARS</b> já foi informada e está trabalhando para corrigir o problema.'
                }
            }
        }

    }

    getMessageException(msg) {
        
        var langExcepts = this.language[this.language.choosen].exceptions;
        var pieces = msg.split(' ');
        
        for (var i = 0; i < pieces.length; i++) {
            if (pieces[i].includes("except_")) {
                            
                var messageToReplace = "";
    
                for (var name in langExcepts) {
                    if (name == pieces[i]) {
                        messageToReplace = langExcepts[name];
                        break;
                    }
                }
    
                msg = msg.replace(pieces[i], messageToReplace);
            }
        }

        return msg
    }
 
}